import { createContext, useContext, useEffect, useState, createElement } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("sv_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sv_token", data.token);
    setUser(data.user);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("sv_token");
    setUser(false);
  };
  return createElement(AuthCtx.Provider, { value: { user, login, logout } }, children);
}

export const useAuth = () => useContext(AuthCtx);
